import { adaptUsuario } from '@/shared/domain/adapters';
import { isRec } from '@/shared/domain/adaptHelpers';
import type { PerfilTipo, Usuario } from '@/shared/domain/types';
import { apiAxios } from '../api';
import { toResult } from '../handlers';
import type { ApiResult } from '../types';
import { priv, sinCuerpo, type RequestOpts } from './common';

/** Perfil del usuario (/v1/usuarios/yo). Todas las rutas son privadas. */
export interface PatchUsuario {
  nombre?: string | null;
  perfilTipo?: PerfilTipo | null;
  regionPrincipal?: string | null;
}

/** Exportación de datos personales (portabilidad): se entrega tal cual para descargarla. */
export type ExportacionUsuario = Record<string, unknown>;

export const usuariosApi = {
  getYo: (opts?: RequestOpts): Promise<ApiResult<Usuario>> =>
    toResult(apiAxios.get({ url: '/usuarios/yo', config: priv(opts) }), adaptUsuario),

  /** Solo viajan los campos presentes. */
  patchYo: (cambios: PatchUsuario, opts?: RequestOpts): Promise<ApiResult<Usuario>> => {
    const data: Record<string, unknown> = {};
    if (cambios.nombre !== undefined) data.nombre = cambios.nombre;
    if (cambios.perfilTipo !== undefined) data.perfil_tipo = cambios.perfilTipo;
    if (cambios.regionPrincipal !== undefined) data.region_principal = cambios.regionPrincipal;
    return toResult(
      apiAxios.patch({ url: '/usuarios/yo', data, config: priv(opts) }),
      adaptUsuario,
    );
  },

  /** Borra la cuenta y todos sus datos. Exige la contraseña. */
  deleteYo: (password: string, opts?: RequestOpts): Promise<ApiResult<void>> =>
    toResult(
      apiAxios.delete({ url: '/usuarios/yo', data: { password }, config: priv(opts) }),
      sinCuerpo,
    ),

  exportarYo: (opts?: RequestOpts): Promise<ApiResult<ExportacionUsuario>> =>
    toResult(apiAxios.get({ url: '/usuarios/yo/exportar', config: priv(opts) }), (raw) => {
      if (!isRec(raw)) throw new Error('exportar: la respuesta no es un objeto');
      return raw;
    }),
};
